import React, { useContext, useState, useEffect } from 'react'
import classNames from 'classnames'
import { LotContext } from '../Lot/LotContext'
import { WemoloTypography } from '../../components/Wemolo'
import styles from './LotOccupancyTrafficLightColor.module.css'

export const LotOccupancyTrafficLightColor = () => {
    const { occupancyValue, fetchOccupancyValue, lastFetchOccupancy } = useContext(LotContext)
    const [secondsAgo, setSecondsAgo] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            if (lastFetchOccupancy) {
                const elapsed = Math.floor((Date.now() - new Date(lastFetchOccupancy).getTime()) / 1000)
                setSecondsAgo(elapsed)
            } else {
                setSecondsAgo(0)
            }
        }, 1000)

        return () => clearInterval(interval)
    }, [lastFetchOccupancy])

    if (!occupancyValue) {
        return <div>-</div>
    }

    console.log('occupancyValue', occupancyValue)
    const trafficLightStatus = occupancyValue?.traffic_light_status || 'red'

    return (
        <div className={styles.root}>
            <div className={styles.trafficLight}>
                <div className={classNames(styles.bulb, { [styles.bulbRed]: trafficLightStatus === 'red' })} />
                <div className={classNames(styles.bulb, { [styles.bulbGreen]: trafficLightStatus === 'green' })} />
            </div>
            <div className={styles.meta}>
                <WemoloTypography variant="label-xsmall" tag="div" className={styles.metaTime}>
                    {secondsAgo}s ago
                </WemoloTypography>
                <button onClick={fetchOccupancyValue} className={styles.refreshButton}>
                    <i className="material-icons">refresh</i>
                </button>
            </div>
        </div>
    )
}
